const carDealershipGiftsCardData = {
    link: '/product-type/car-dealership-gifts/',
    title: "Car Dealership Gifts",
    name: "Car Dealership Gifts",
    image: {
      sourceUrl:
        'https://cart.gourmetbasket.com.au/wp-content/uploads/2025/03/Car-Dealership-Tile-01.jpg',
      altText: "Car Dealership Gifts",
      sizes: '',
      title: "Car Dealership Gifts",
    },
    id: 1984,
  };
  
  export default carDealershipGiftsCardData;
  